/* eslint-disable max-lines */
/* eslint quote-props: ["error", "as-needed", { "keywords": true, "unnecessary": false }] */
/* eslint-disable comma-dangle */
import MasterView from '../components/MasterView';
import ReactLogin from '../components/account/Login.vue';


export default [
  // apps
  {
    path: '/apps',
    component: MasterView,
    meta: {
      auth: true,
    },
    children: [
      {
        path: '',
        name: 'apps',
        component: () =>
          import(
            /* webpackChunkName: "apps-list" */ '../components/app/AppsList'
          ),
      },
      {
        path: ':packageName',
        component: () =>
          import(
            /* webpackChunkName: "app-view" */ '../components/app/AppView'
          ),
        children: [
          {
            path: '',
            name: 'apps-view',
            redirect: 'dashboard',
          },
          {
            path: 'dashboard',
            name: 'app-dashboard',
            component: () =>
              import(
                /* webpackChunkName: "app-view" */ '../components/app/AppDashboard'
              ),
          },
          {
            path: 'info',
            name: 'app-info',
            component: () =>
              import(
                /* webpackChunkName: "app-view" */ '../components/app/AppInfo'
              ),
          },
          {
            path: 'media',
            name: 'app-media',
            component: () =>
              import(
                /* webpackChunkName: "app-view" */ '../components/app/AppMedia'
              ),
            meta: {
              auth: ['publisher', 'blockedPublisher', 'changeAppInfo'],
            },
          },
          {
            path: 'packages',
            name: 'app-packages',
            redirect: 'releases',
          },
          {
            path: 'releases',
            name: 'app-releases',
            redirect: 'releases/management',
            meta: {
              auth: ['publisher', 'blockedPublisher', 'development'],
            },
          },
          {
            path: 'releases/management',
            name: 'app-releases-management',
            component: () =>
              import(
                /* webpackChunkName: "app-view" */ '../components/app/AppReleases'
              ),
            meta: {
              auth: ['publisher', 'blockedPublisher', 'development'],
            },
          },
          {
            path: 'releases/group',
            name: 'app-releases-group',
            component: () =>
              import(
                /* webpackChunkName: "app-view" */ '../components/app/AppReleases/Group'
              ),
            meta: {
              auth: ['publisher', 'blockedPublisher', 'development'],
            },
          },
          {
            path: 'releases/group/:groupId',
            name: 'app-releases-group-detail',
            component: () =>
              import(
                /* webpackChunkName: "app-view" */ '../components/app/AppReleases/Group/Detail'
              ),
            meta: {
              auth: ['publisher', 'blockedPublisher', 'development'],
            },
          },
          {
            path: 'in-app-purchases',
            name: 'in-app-purchases',
            redirect: 'in-app-purchases/products',
            meta: {
              auth: ['publisher', 'blockedPublisher', 'development'],
            },
          },
          {
            path: 'in-app-billing/products',
            name: 'in-app-billing-products',
            redirect: 'in-app-purchases/products',
            meta: {
              auth: ['publisher', 'blockedPublisher', 'development'],
            },
          },
          {
            path: 'in-app-billing/settings',
            name: 'in-app-billing-settings',
            redirect: 'in-app-purchases/settings',
            meta: {
              auth: ['publisher', 'blockedPublisher', 'development'],
            },
          },
          {
            path: 'in-app-purchases/products',
            name: 'in-app-purchases-products',
            component: () =>
              import(
                /* webpackChunkName: "app-view" */ '../components/app/in-app-billing/InAppBillingProducts'
              ),
            meta: {
              auth: ['publisher', 'blockedPublisher', 'development'],
            },
          },
          {
            path: 'in-app-purchases/settings',
            name: 'in-app-purchases-settings',
            component: () =>
              import(
                /* webpackChunkName: "app-view" */ '../components/app/in-app-billing/InAppBillingSettings'
              ),
            meta: {
              auth: ['publisher', 'blockedPublisher', 'development'],
            },
          },
          {
            path: 'tickets',
            name: 'app-tickets',
            component: ReactLogin,
            meta: {
              auth: ['publisher', 'support', 'blockedPublisher'],
            },
          },
          {
            path: 'tickets/:id',
            name: 'app-ticket-detail',
            component: ReactLogin,
            meta: {
              auth: ['publisher', 'support', 'blockedPublisher'],
            },
          },
          {
            path: 'reviews',
            name: 'app-reviews',
            component: () =>
              import(
                /* webpackChunkName: "app-view" */ '../components/app/AppReviews'
              ),
            meta: {
              auth: ['publisher', 'support', 'blockedPublisher'],
            },
          },
          {
            path: 'transactions',
            redirect: 'transactions/purchases',
            name: 'transactions',
          },
          {
            path: 'transactions/purchases',
            name: 'transactions-purchases',
            component: () =>
              import(
                /* webpackChunkName: "app-view" */ '../components/app/transactions/TransactionsPurchases'
              ),
            meta: {
              auth: ['publisher', 'blockedPublisher', 'viewFinance'],
            },
          },
          {
            path: 'transactions/sub-purchases',
            name: 'transactions-sub-purchases',
            component: () =>
              import(
                /* webpackChunkName: "app-view" */ '../components/app/transactions/TransactionsSubPurchases'
              ),
            meta: {
              auth: ['publisher', 'blockedPublisher', 'viewFinance'],
            },
          },
          {
            path: 'stats-builder',
            name: 'stats-builder',
            props: true,
            component: () =>
              import(
                /* webpackChunkName: "app-stats" */ '../components/app/StatsBuilder'
              ),
            meta: {
              auth: ['publisher', 'blockedPublisher', 'statistics'],
            },
          },
          {
            path: 'oauth',
            name: 'oauth',
            component: () =>
              import(
                /* webpackChunkName: "app-view" */ '../components/app/OAuth'
              ),
            meta: {
              auth: ['publisher', 'blockedPublisher', 'developersApi'],
            },
          },
          {
            path: 'sales-report',
            name: 'sales-report',
            component: () =>
              import(
                /* webpackChunkName: "app-view" */ '../components/app/AppSalesReport'
              ),
            meta: {
              auth: ['publisher', 'blockedPublisher', 'viewFinance'],
            },
          },
          {
            path: 'api-agents',
            name: 'app-api-agents',
            component: () =>
              import(
                /* webpackChunkName: "app-view" */ '../components/app/AppApiAgents'
              ),
            meta: {
              auth: ['publisher', 'blocked_publisher', 'development'],
            },
          },
        ],
      },
    ],
  },
  {
    path: '/draft-apps',
    component: MasterView,
    meta: {
      auth: ['publisher', 'blockedPublisher', 'addApp'],
    },
    children: [
      {
        path: ':appId',
        name: 'draft-app',
        component: () =>
          import(
            /* webpackChunkName: "app-creation-wizard" */ '../components/app/AppCreationWizard'
          ),
      },
    ],
  },
  // settings
  {
    path: '/settings',
    component: MasterView,
    meta: {
      auth: true,
    },
    children: [
      {
        path: '',
        name: 'settings',
        redirect: 'account-status',
      },
      {
        path: 'account-status',
        name: 'account-status',
        component: () =>
          import(
            /* webpackChunkName: "account" */ '../components/account/AccountStatus'
          ),
        meta: {
          auth: ['publisher', 'changePublicInfo'],
        },
      },
      {
        path: 'agent-information',
        name: 'agent-information',
        component: () =>
          import(
            /* webpackChunkName: "account" */ '../components/account/account-info/AgentInfo'
          ),
        meta: {
          auth: ['agent'],
        },
      },
      {
        path: 'change-password',
        name: 'change-password',
        component: () =>
          import(
            /* webpackChunkName: "account" */ '../components/account/account-info/ChangePassword'
          ),
      },
      {
        path: 'two-step-verification',
        name: 'two-step-verification',
        component: () =>
          import(
            /* webpackChunkName: "settings" */ '../components/settings/two-step-verification/TwoStepVerificationPage'
          ),
      },
      {
        path: 'publisher',
        name: 'publisher',
        component: () =>
          import(
            /* webpackChunkName: "publisher" */ '../components/account/Publisher'
          ),
        meta: {
          auth: ['publisher', 'changePublicInfo'],
        },
      },
      {
        path: 'contract',
        name: 'contract',
        component: () =>
          import(
            /* webpackChunkName: "settings" */ '../components/settings/Contract'
          ),
        meta: {
          auth: ['publisher', 'changePublicInfo'],
        },
      },
      {
        path: 'api',
        name: 'developers-api',
        component: () =>
          import(
            /* webpackChunkName: "settings" */ '../components/settings/DevelopersAPI'
          ),
        meta: {
          auth: ['publisher', 'blockedPublisher', 'developersApi'],
        },
      },
      {
        path: 'developers-titles',
        name: 'developers-titles',
        component: () =>
          import(
            /* webpackChunkName: "settings" */ '../components/settings/DeveloperTitles'
          ),
        meta: {
          auth: ['publisher', 'blockedPublisher', 'changePublicInfo'],
        },
      },
      {
        path: 'agents',
        name: 'agents',
        component: () =>
          import(
            /* webpackChunkName: "agents" */ '../components/settings/Agents'
          ),
        meta: {
          auth: ['publisher'],
        },
      },
    ],
  },
  // reports
  {
    path: '/finance',
    component: MasterView,
    meta: {
      auth: ['publisher', 'blockedPublisher', 'viewFinanceInfo'],
    },
    children: [
      {
        path: '',
        name: 'finance',
        redirect: 'settlement',
      },
      {
        path: 'settlement',
        name: 'settlement',
        redirect: 'settlement/history',
        component: () =>
          import(
            /* webpackChunkName: "finance" */ '../components/finance/settlement/SettlementView'
          ),
        children: [
          {
            path: 'history',
            name: 'settlement-history',
            component: () =>
              import(
                /* webpackChunkName: "finance" */ '../components/finance/settlement/SettlementHistory'
              ),
          },
          {
            path: 'settings',
            name: 'settlement-settings',
            component: () =>
              import(
                /* webpackChunkName: "finance" */ '../components/finance/settlement/SettlementSettings'
              ),
            meta: {
              auth: ['publisher', 'blockedPublisher', 'changeFinanceInfo'],
            },
          },

          // {
          //   path: 'tax-history',
          //   name: 'settlement-tax-history',
          //   component: () => import(/* webpackChunkName: "finance" */
          //   '../components/finance/settlement/SettlementTaxHistory'),
          //   meta: {
          //     auth: ['publisher', 'blockedPublisher', 'viewFinanceInfo']
          //   }
          // },
          {
            path: 'misc',
            name: 'settlement-misc',
            component: () =>
              import(
                /* webpackChunkName: "finance" */ '../components/finance/settlement/SettlementMisc'
              ),
            meta: {
              auth: ['publisher', 'blockedPublisher', 'viewFinanceInfo'],
            },
          },
        ],
      },
      {
        path: 'sales',
        redirect: 'sales/invoice',
      },
      {
        path: 'sales/invoice',
        name: 'sales-invoice',
        component: () =>
          import(
            /* webpackChunkName: "finance" */ '../components/finance/SalesReports'
          ),
      },
      {
        path: 'sales/chart',
        name: 'sales-chart',
        component: () =>
          import(
            /* webpackChunkName: "finance" */ '../components/finance/SalesChart'
          ),
      },
    ],
  },
  // advertisement
  {
    path: '/advertisement',
    component: MasterView,
    meta: {
      auth: ['advertisement'],
      // Gated by the `show_ads` feature flag (see checkFeatureFlags middleware).
      requiresAds: true,
    },
    children: [
      {
        path: '',
        name: 'advertisement',
        redirect: { name: 'advertisement-manage-campaigns' },
      },
      {
        path: 'manage-campaigns',
        name: 'advertisement-manage-campaigns',
        meta: {
          auth: ['adTester'],
        },
        component: () =>
          import(
            /* webpackChunkName: "tablighat" */ '../components/advertisement/overview/OverviewPage'
          ),
      },
      {
        path: 'reporting',
        name: 'advertisement-reporting',
        meta: {
          auth: ['adTester'],
        },
        component: () =>
          import(
            /* webpackChunkName: "tablighat" */ '../components/advertisement/reporting/ReportingPage'
          ),
      },
      {
        path: 'finance',
        component: () =>
          import(
            /* webpackChunkName: "tablighat" */ '../components/advertisement/finance/Budget'
          ),
        children: [
          {
            path: '',
            name: 'advertisement-finance',
            redirect: 'transactions',
          },
          {
            path: 'transactions',
            name: 'finance-transactions',
            component: () =>
              import(
                /* webpackChunkName: "tablighat" */ '../components/advertisement/finance/Transactions'
              ),
            props: route => ({
              state: route.query.state,
              invoiceId: route.query.invoice,
            }),
          },
          {
            path: 'invoice',
            name: 'finance-invoice',
            component: () =>
              import(
                /* webpackChunkName: "tablighat" */ '../components/advertisement/finance/Invoice'
              ),
            meta: {
              staging: true,
            },
          },
        ],
      },
      {
        path: 'campaigns',
        name: 'advertisement-campaigns',
        component: () =>
          import(
            /* webpackChunkName: "tablighat" */ '../components/advertisement/Campaigns'
          ),
        children: [
          {
            path: 'discovery-ads',
            name: 'discovery-ads-campaigns-list',
            component: () =>
              import(
                /* webpackChunkName: "tablighat" */ '../components/advertisement/Campaigns/DiscoveryAdsCampaignList'
              ),
          },
          {
            path: 'search-ads',
            name: 'search-ads-campaigns-list',
            component: () =>
              import(
                /* webpackChunkName: "tablighat" */ '../components/advertisement/Campaigns/SearchAdsCampaigns'
              ),
          },
          {
            path: 'basic-ads',
            name: 'basic-ads-campaigns-list',
            component: () =>
              import(
                /* webpackChunkName: "tablighat" */ '../components/advertisement/Campaigns/BasicAdsCampaignsList'
              ),
          },
        ],
      },
      {
        path: 'campaigns/create',
        name: 'advertisement-create-campaign',
        component: () =>
          import(
            /* webpackChunkName: "tablighat" */ '../components/advertisement/Campaigns/CampaignCreatePage.vue'
          ),
      },
      {
        path: 'campaigns/search-ads/:campaignId',
        component: () =>
          import(
            /* webpackChunkName: "tablighat" */ '../components/advertisement/search-ads/CampaignView'
          ),
        children: [
          {
            path: '',
            name: 'search-ads-campaign',
            redirect: 'info',
          },
          {
            path: 'info',
            name: 'search-ads-campaign-info',
            component: () =>
              import(
                /* webpackChunkName: "tablighat" */ '../components/advertisement/search-ads/CampaignInfo'
              ),
          },
          {
            path: 'bids',
            name: 'search-ads-campaign-bids',
            component: () =>
              import(
                /* webpackChunkName: "tablighat" */ '../components/advertisement/search-ads/Bids'
              ),
          },
          {
            path: 'bids/bulk',
            name: 'search-ads-add-bulk-bids',
            component: () =>
              import(
                /* webpackChunkName: "tablighat-bulk-import" */ '../components/advertisement/search-ads/Bids/BidsAddBulk'
              ),
          },
          {
            path: 'negative-keywords',
            name: 'search-ads-negative-keywords',
            component: () =>
              import(
                /* webpackChunkName: "tablighat" */ '../components/advertisement/search-ads/NegativeKeywords'
              ),
          },
          {
            path: 'search-terms',
            name: 'search-ads-search-terms',
            component: () =>
              import(
                /* webpackChunkName: "tablighat" */ '../components/advertisement/search-ads/SearchTerms'
              ),
          },
          {
            path: 'stats',
            name: 'search-ads-campaign-stats-overall',
            component: () =>
              import(
                /* webpackChunkName: "tablighat" */ '../components/advertisement/search-ads/stats/CampaignOverall'
              ),
          },
          {
            path: 'stats-builder',
            name: 'search-ads-campaign-stats-builder',
            component: () =>
              import(
                /* webpackChunkName: "tablighat" */ '../components/advertisement/search-ads/stats/CampaignStatsBuilder'
              ),
          },
          {
            path: 'campaign-finance',
            name: 'search-ads-campaign-finance',
            component: () =>
              import(
                /* webpackChunkName: "tablighat" */ '../components/advertisement/search-ads/CampaignFinance'
              ),
          },
        ],
      },
      {
        path: 'campaigns/discovery-ads/:campaignId',
        component: () =>
          import(
            /* webpackChunkName: "tablighat" */ '../components/advertisement/discovery-ads/CampaignView'
          ),
        children: [
          {
            path: '',
            name: 'discovery-ads-campaign',
            redirect: 'info',
          },
          {
            path: 'info',
            name: 'discovery-ads-campaign-info',
            component: () =>
              import(
                /* webpackChunkName: "tablighat" */ '../components/advertisement/discovery-ads/CampaignInfo'
              ),
          },
          {
            path: 'stats',
            name: 'discovery-ads-campaign-stats-overall',
            component: () =>
              import(
                /* webpackChunkName: "tablighat" */ '../components/advertisement/discovery-ads/DiscoveryCampaignStats'
              ),
          },
        ],
      },
      {
        path: 'campaigns/basic-ads/:campaignId',
        component: () =>
          import(
            /* webpackChunkName: "tablighat" */ '../components/advertisement/basic-ads/CampaignView'
          ),
        children: [
          {
            path: '',
            name: 'basic-ads-campaign',
            redirect: 'info',
          },
          {
            path: 'info',
            name: 'basic-ads-campaign-info',
            component: () =>
              import(
                /* webpackChunkName: "tablighat" */ '../components/advertisement/basic-ads/CampaignInfo'
              ),
          },
          {
            path: 'stats',
            name: 'basic-ads-campaign-stats-overall',
            component: () =>
              import(
                /* webpackChunkName: "tablighat" */ '../components/advertisement/basic-ads/CampaignStatsOverall'
              ),
          },
        ],
      },
      {
        path: 'keyword-planner',
        name: 'advertisement-keyword-planner',
        component: () =>
          import(
            /* webpackChunkName: "tablighat" */ '../components/advertisement/KeywordPlanner'
          ),
      },
      {
        path: 'mail-service',
        name: 'advertisement-mail-service',
        component: () =>
          import(
            /* webpackChunkName: "tablighat" */ '../components/advertisement/MailService'
          ),
      },
      {
        // SearchAds route has been changed, so this redirection helps us to support the old links
        path: 'campaigns/:campaignId/*',
        redirect: to => {
          const existingPaths = [
            '',
            'info',
            'bids',
            'negative-keywords',
            'search-terms',
            'insight',
            'stats',
            'stats-builder',
            'notifications',
            'campaign-finance',
          ];
          const pathMatchExists = existingPaths.includes(to.params.pathMatch);

          if (pathMatchExists) {
            return to.fullPath.replace('/campaigns', '/campaigns/search-ads');
          } else {
            return '/apps';
          }
        },
      },
    ],
  },
  // support
  {
    path: '/support',
    meta: {
      auth: true,
    },
    component: MasterView,
    children: [
      {
        path: '',
        name: 'support',
        redirect: 'tickets',
      },
      {
        path: 'tickets',
        name: 'tickets',
        component: ReactLogin,
        meta: {
          auth: true,
        },
      },
      {
        path: 'tickets/new-ticket',
        name: 'new-ticket',
        component: ReactLogin,
        meta: {
          auth: true,
        },
      },
      {
        path: 'tickets/:id',
        name: 'ticket-detail',
        component: ReactLogin,
        meta: {
          auth: true,
        },
      },
      {
        path: 'contact-us',
        name: 'contact-us',
        component: () =>
          import(
            /* webpackChunkName: "support" */ '../components/support/ContactUs'
          ),
        meta: {
          auth: true,
        },
      },
      {
        path: 'faq',
        name: 'faq',
        component: ReactLogin,
        meta: {
          auth: true,
        },
      },
    ],
  },
  // bazaargah
  {
    path: '/bazaargah/home',
    name: 'bazaargah-home',
    component: ReactLogin,
    meta: {
      auth: true,
    },
  },
  {
    path: '/bazaargah/applets/:slug',
    name: 'bazaargah-applet-detail',
    component: ReactLogin,
    meta: {
      auth: true,
    },
  },
  //account
  {
    path: '/account/logout',
    name: 'logout',
    component: () =>
      import(/* webpackChunkName: "auth" */ '../components/account/Logout'),
    meta: {
      auth: true,
    },
  },
  {
    path: '/account/register/steps',
    name: 'register-steps',
    meta: {
      auth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "auth" */ '../components/account/RegisterSteps'
      ),
  },
  {
    path: '/verify-email',
    name: 'verify-email',
    component: () =>
      import(
        /* webpackChunkName: "auth" */ '../components/account/VerifyEmail'
      ),
  },
  {
    path: '/account/register-agent',
    name: 'register-agent',
    component: () =>
      import(
        /* webpackChunkName: "auth" */ '../components/account/RegisterAgent'
      ),
  },
  {
    path: '/account/extend-membership/',
    name: 'verify-extend-membership',
    component: () =>
      import(
        /* webpackChunkName: "account" */ '../components/account/VerifyExtendMembership'
      ),
  },
  {    
    path: '/account/:pathMatch(.*)*',
    name:'login',
    component: ReactLogin,
    meta: { auth: false },
  },
  {
    path: '/email/',
    name: 'email',
    component: () =>
      import(/* webpackChunkName: "email" */ '../components/Email'),
  },
  {
    path: '/',
    redirect: '/apps',
  },
  {
    path: '*',
    redirect: '/apps',
  },
];
